export default __webpack_public_path__ + "static/media/usersIcon.00885f18.svg";